import { render, staticRenderFns } from "./customSettings.vue?vue&type=template&id=722edd50&scoped=true&"
import script from "./customSettings.vue?vue&type=script&lang=js&"
export * from "./customSettings.vue?vue&type=script&lang=js&"
import style0 from "./customSettings.vue?vue&type=style&index=0&id=722edd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722edd50",
  null
  
)

export default component.exports